import type { App } from 'vue';
import { createVuetify } from 'vuetify';
import { iconSet } from "./customSVGs";
import '../../styles/vuetify/_index.scss';
import { VTreeview } from 'vuetify/components/VTreeview';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import { useI18n } from 'vue-i18n';

export interface ThemeColorsInterface {
  primaryColor: string;
  logoPath: string;
  iconPath: string;
};

export const registerVuetify = (app: App, themeData: ThemeColorsInterface, i18n: any) => app.use(createVuetify({
  components: {
    VTreeview,
  },
  icons: {
    sets: {
      custom: iconSet,
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          background: '#f5f5f5',
          primary: themeData?.primaryColor ?? '#231F20',
          secondary: '#b0bec5',
          'blue-lighten-1': '#42A5F5',
        },
      },
    },
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
}));
